import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardDto } from '../models/dashboard';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private url = 'api/treinoUsuario';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getDashboard(): Observable<DashboardDto> {
    return this.http.get<DashboardDto>(`${this.url}/dashboard`);
  }
}
